import '../scss/customize.scss';

import Utility from "./class/utility";
import CUSTOMIZE from "./extended_class/customize";
import HOME from "./module/home";
import PRICE from "./module/price";
import CASE from "./module/case";
import VOICE from "./module/voice";
import INFORMATION from "./module/information";
import SEMINAR from './module/seminar';

// ユーティリティクラスのインスタンス化
const UTIL = new Utility();

// テンプレートインスタンス化（promise登録）
const TPL = new CUSTOMIZE();

// URLによる関数の実行
UTIL.loader( (request, path) => {
  switch( path ){
    case '/': HOME(); break
    case '/price/': PRICE(); break
    case '/case/': CASE(); break
    case '/voice/': VOICE(); break
    case '/information/': INFORMATION(); break
    case '/seminar/': SEMINAR(); break
  }
  // switch( request ){}
});

// テンプレートインスタンスの初期化（イベント発火）
TPL.init();